import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';

const appId = import.meta.env.VITE_NEWRELIC_APP_ID || '106942725';

const options = {
  "info": {
    "applicationID": appId,
    "beacon": "bam.nr-data.net",
    "errorBeacon": "bam.nr-data.net",
    "licenseKey": "e0c03b9757",
    "sa": 1
  },
  "init": {
    "ajax": {
      "deny_list": [
        "bam.nr-data.net"
      ]
    },
    "browser_consent_mode": {
      "enabled": false
    },
    "distributed_tracing": {
      "enabled": true
    },
    "performance": {
      "capture_detail": false,
      "capture_marks": false,
      "capture_measures": true
    },
    "privacy": {
      "cookies_enabled": true
    }
  },
  "loader_config": {
    "accountID": 1250462,
    "agentID": Number(appId),
    "applicationID": Number(appId),
    "licenseKey": "e0c03b9757",
    "trustKey": 1250462
  }
}

export function initNewRelic() {
  const environment = window.location.hostname.split('.')[1];
  if (environment === 'cl04') return;

  new BrowserAgent(options);
}
